import React, { createRef } from 'react'
import Translation from '../global/Translation'

import LocalizedLink from '../global/LocalizedLink'
import { cloneDeep, values } from 'lodash'
import Slider from 'react-slick'
import { defineMessages } from 'react-intl'
import ProductTypes from '../catalog/ProductTypes'

defineMessages({
    special_custom_projects: {
        id: 'special_custom_projects',
        description: 'special_custom_projects',
        defaultMessage: 'Special custom projects'
    },
    custom_flooring: {
        id: 'custom_flooring',
        description: 'custom_flooring',
        defaultMessage: 'Custom flooring'
    },
    wall_clading: {
        id: 'wall_clading',
        description: 'wall_clading',
        defaultMessage: 'Wall clading'
    },
    cladding: {
        id: 'cladding',
        description: 'cladding',
        defaultMessage: 'Cladding'
    },
    baseboards: {
        id: 'baseboards',
        description: 'baseboards',
        defaultMessage: 'Baseboards'
    },
    prexury: {
        id: 'prexury',
        description: 'prexury',
        defaultMessage: 'Prexury'
    },
    scalea: {
        id: 'scalea',
        description: 'scalea',
        defaultMessage: 'Scalea'
    },
    vanities: {
        id: 'vanities',
        description: 'vanities',
        defaultMessage: 'Vanities'
    },
    sensa: {
        id: 'sensa',
        description: 'sensa',
        defaultMessage: 'Sensa'
    },
    colorsil: {
        id: 'colorsil',
        description: 'colorsil',
        defaultMessage: 'Colorsil'
    },
    flooring_cladding: {
        id: 'flooring_cladding',
        description: 'flooring_cladding',
        defaultMessage: 'Flooring cladding'
    },
    treatment_and_repair: {
        id: 'treatment_and_repair',
        description: 'treatment_and_repair',
        defaultMessage: 'Treatment and repair'
    },
    maintenance_and_cleaning: {
        id: 'maintenance_and_cleaning',
        description: 'maintenance_and_cleaning',
        defaultMessage: 'Maintenance and cleaning'
    },
    silicones: {
        id: 'silicones',
        description: 'silicones',
        defaultMessage: 'Silicones'
    },
    adhesives: {
        id: 'adhesives',
        description: 'adhesives',
        defaultMessage: 'Adhesives'
    },
    tools: {
        id: 'tools',
        description: 'tools',
        defaultMessage: 'Tools'
    },
    basin_and_washbasin: {
        id: 'basin_and_washbasin',
        description: 'basin_and_washbasin',
        defaultMessage: 'Basin and washbasin'
    },
    eclos: {
        id: "eclos",
        description: "eclos",
        defaultMessage: "Eclos"
    },
    slabs: {
        id: "slabs",
        description: "slabs",
        defaultMessage: "Slabs"
    },
    kitchen_and_bathroom_accessories: {
        id: "kitchen_and_bathroom_accessories",
        description: "kitchen_and_bathroom_accessories",
        defaultMessage: "Kitchen and bathroom accessories"
    },
    professional_products: {
        id: "professional_products",
        description: "professional_products",
        defaultMessage: "Professional Products"
    },
})

class MenuLinksV2 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            props: props
        }
    }

    render() {
        const { centerPreferences } = this.props
        const { responsive, customClass, mktoolShippingCenter } = this.state.props

        const canViewProductGroup = (groups) => {
            const centerPreferences = this.props.centerPreferences
            const canViewProductTypes = centerPreferences && centerPreferences.canViewProductTypes
            if (!canViewProductTypes) return false

            const allKeys = groups.flatMap(group => {
                if (typeof group.toArray === 'function') {
                    return group.toArray()
                } else {
                    return [group.toString()]
                }
            }).map(type => type.toLowerCase().replace(/\s+/g, '_'))

            return allKeys.some(key => canViewProductTypes[key])
        }

        const canViewCladdingProducts = () => {
            return canViewProductGroup([
                ProductTypes.FLOORING_AND_CLADDING_DERIVATED.CLAD,
                ProductTypes.FLOORING_AND_CLADDING_DERIVATED.CLAD_FLOOR,
                ProductTypes.COVERING
            ])
        }

        const canViewProfessionalProducts = () => {
            return canViewProductGroup([ProductTypes.PROFESSIONAL])
        }

        const canViewStandardProducts = () => {
            return canViewProductGroup([
                ProductTypes.BATHROOM,
                ProductTypes.COVERING,
                ProductTypes.FLOORING_AND_CLADDING,
                ProductTypes.FLOORING_AND_CLADDING_DERIVATED
            ])
        }

        const canViewFlooringProducts = () => {
            return canViewProductGroup([
                ProductTypes.FLOORING_AND_CLADDING_DERIVATED.FLOOR,
                ProductTypes.FLOORING_AND_CLADDING_DERIVATED.CLAD_FLOOR,
            ])
        }

        const getQueryStringFromTypes = (types) => {
            // Si types es un objeto ProductTypeGroup, convertirlo a array
            const typeArray = types.toArray ? types.toArray() : Array.isArray(types) ? types : [types]
           
            // Construir los parámetros type[]
            const typeParams = typeArray
              .map((type, index) => `type[${index}]=${encodeURIComponent(type)}`)
              .join('&')
           
            return `?${typeParams}`
        }

        const showMall = () => {
            let control = false
            if (this.props.userLandings && this.props.userLandings.length > 0 && this.props.isMallPilotUser) {
                this.props.userLandings.map(landing => {
                    let today = new Date()
                    if (new Date(landing.end_at) > today) {
                        control = true
                    }
                })
                return control
            }
            return false
        }
        const getMallLink = () => {
            if (this.props.userLandings && this.props.userLandings.length > 0) {
                for (let i = 0; i < this.props.userLandings.length; i++) {
                    let today = new Date()
                    if (new Date(this.props.userLandings[i].end_at) > today) {
                        return this.props.userLandings[i].slug
                    }
                }
            } else {
                return 'test'
            }
        }

        const brandLinks = []
        // if (
        //     !this.props.isNoSilestoneCenter && // Verifica si no es un centro que no vende Silestone
        //     (!this.props.isAustralianCenter || this.props.isSilestoneBrandVisible) // Verifica si no es Australia o si hay stock
        // ) {
        //     brandLinks.push({
        //         name: 'Silestone',
        //         queryString: `?type[0]=SLAB&brand[0]=SILESTONE`,
        //         routeId: 'ROUTE_CATALOG',
        //         translationId: 'silestone',
        //         params: { outlet: '' },
        //         dataQas: 'global_header-silestone-menu-link-child',
        //         show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_silestone
        //     })
        // }

        brandLinks.push({
            name: 'Silestone',
            queryString: `?type[0]=SLAB&brand[0]=SILESTONE`,
            routeId: 'ROUTE_CATALOG',
            translationId: 'silestone',
            params: { outlet: '' },
            dataQas: 'global_header-silestone-menu-link-child',
            show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_silestone
        })

        brandLinks.push({
            name: this.props.selectedCenter == 7130 ? 'DKTN' : 'Dekton',
            translationId: this.props.selectedCenter == 7130 ? 'DKTN' : 'dekton',
            queryString: this.props.selectedCenter == 7130 ? `?type[0]=SLAB&brand[0]=DKTN` : `?type[0]=SLAB&brand[0]=DEKTON`,
            routeId: 'ROUTE_CATALOG',
            params: { outlet: '' },
            dataQas: 'global_header-dekton-menu-link-child',
            show:
                this.props.selectedCenter == 7130
                    ? centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_dktn
                    : centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_dekton
        })

        brandLinks.push({
            name: 'Eclos',
            translationId: 'eclos',
            queryString: `?type[0]=SLAB&brand[0]=ECLOS`,
            routeId: 'ROUTE_CATALOG',
            params: { outlet: '' },
            dataQas: 'global_header-eclos-menu-link-child',
            show: (
                this.props.isPriorityCustomerForEclos ||
                this.props.isAustralianCenter ||
                this.props.canViewEclosBrandInEurope ||
                this.props.isSelectedCenterAvailableToBuyEclosProducts ||
                this.props.isEclosGlobalDistributor ||
                this.props.isEMEACustomerForEclosGlobal
            ) && centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_eclos
        })

        const naturalStoneBrandLinks = [
            {
                name: 'Scalea',
                translationId: 'scalea',
                queryString: `?type[0]=SLAB&brand[0]=SCALEA`,
                routeId: 'ROUTE_CATALOG',
                params: { outlet: '' },
                dataQas: 'global_header-scalea-menu-link-child',
                show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_scalea
            },
            {
                name: 'Sensa',
                translationId: 'sensa',
                queryString: `?type[0]=SLAB&brand[0]=SENSA`,
                routeId: 'ROUTE_CATALOG',
                params: { outlet: '' },
                dataQas: 'global_header-sensa-menu-link-child',
                show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_sensa
            },
            {
                name: 'Prexury',
                translationId: 'prexury',
                queryString: `?type[0]=SLAB&brand[0]=PREXURY`,
                routeId: 'ROUTE_CATALOG',
                params: { outlet: '' },
                dataQas: 'global_header-prexury-menu-link-child',
                show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab_prexury
            }
        ]

        const allBrandLinks = [...brandLinks, ...naturalStoneBrandLinks]
        const outletBrandLinks = allBrandLinks.map(link => {
            return {
                ...link,
                params: { ...link.params, outlet: 'outlet' },
                queryString: link.queryString.replace('type[0]=SLAB&', ''),
                dataQas: ''
            }
        })

        let linksMenu = [
            // SLABS
            {
                name: 'slabs',
                routeId: 'ROUTE_CATALOG',
                params: { outlet: '' },
                queryString: getQueryStringFromTypes(ProductTypes.SLAB),
                translationId: 'tables',
                customClassTag: 'slabs',
                show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab && this.props.canViewCatalog,
                dataQas: 'global_header-slabs-menu-link',
                gtmLabel: 'ec_menu_header-slabs',
                links: this.props.canViewNaturalStoneSection ? [
                    ...brandLinks,
                    {
                        name: 'Natural Stone',
                        translationId: 'natural_stone',
                        isNaturalStoneGroupTitle: true,
                        routeId: 'ROUTE_NATURAL_STONE',
                        params: { outlet: '' },
                        links: naturalStoneBrandLinks
                    }
                ] : allBrandLinks
            },
            // Standard Products
            {
                name: 'standard products',
                routeId: 'ROUTE_CATALOG',
                queryString: getQueryStringFromTypes([
                    ...ProductTypes.BATHROOM.toArray(),
                    ...ProductTypes.COVERING.toArray(),
                    ...ProductTypes.FLOORING_AND_CLADDING.toArray(),
                    ...ProductTypes.FLOORING_AND_CLADDING_DERIVATED.toArray()
                ]),
                params: { outlet: '' },
                translationId: 'standard_products',
                customClassTag: 'standard',
                show: this.props.canViewCatalog && !this.props.canViewMktools && canViewStandardProducts(),
                dataQas: 'global_header-standard-products-menu-link',
                gtmLabel: 'ec_menu_header-sinks',
                links: [
                    {
                        name: 'Flooring',
                        queryString: getQueryStringFromTypes([
                            ProductTypes.FLOORING_AND_CLADDING_DERIVATED.FLOOR,
                            ProductTypes.FLOORING_AND_CLADDING_DERIVATED.CLAD_FLOOR,
                        ]),
                        routeId: 'ROUTE_CATALOG',
                        translationId: 'FLOOR',
                        params: { outlet: '' },
                        dataQas: 'global_header-flooring-menu-link-child',
                        show: canViewFlooringProducts()
                    },
                    {
                        name: 'Cladding',
                        queryString: getQueryStringFromTypes([
                            ProductTypes.FLOORING_AND_CLADDING_DERIVATED.CLAD,
                            ProductTypes.FLOORING_AND_CLADDING_DERIVATED.CLAD_FLOOR,
                            ...ProductTypes.COVERING.toArray()
                        ]),
                        routeId: 'ROUTE_CATALOG',
                        translationId: 'cladding',
                        params: { outlet: '' },
                        dataQas: 'global_header-cladding-menu-link-child',
                        show: canViewCladdingProducts()
                    },
                    {
                        name: 'Sinks',
                        queryString: getQueryStringFromTypes(ProductTypes.BATHROOM.SINK),
                        translationId: 'sinks',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-sinks-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.sink
                    },
                    {
                        name: 'Shower Trays',
                        queryString: getQueryStringFromTypes(ProductTypes.BATHROOM.STRAY),
                        translationId: 'strays',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-shower-trays-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.stray
                    },
                    {
                        name: 'Bathroom basin and washbasin',
                        translationId: 'basin_and_washbasin',
                        queryString: getQueryStringFromTypes([
                            ProductTypes.BATHROOM.BASIN, 
                            ProductTypes.BATHROOM.VANITY
                        ]),
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-vanities-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.vanity
                    }
                ]
            },
            // Custom products
            {
                name: 'custom products',
                routeId: 'ROUTE_CUT_TO_SIZE',
                queryString: '',
                translationId: 'custom_products',
                params: { outlet: '' },
                customClassTag: 'cts',
                show: this.props.canViewCutToSize && this.props.isLogged,
                dataQas: 'global_header-custom-products-menu-link',
                gtmLabel: 'ec_menu_header-elaborados',
                links: [
                    {
                        name: 'Cut to Size',
                        queryString: '?type=solo_corte',
                        routeId: 'ROUTE_CUT_TO_SIZE',
                        translationId: 'solo_corte',
                        params: { outlet: '' },
                        dataQas: 'global_header-cts-menu-link-child',
                        show: true
                    },
                    {
                        name: 'Flooring & Skirting',
                        queryString: '?type=flooring',
                        translationId: 'flooring_baseboard',
                        routeId: 'ROUTE_CONFIG_CUT_TO_SIZE',
                        params: { type: 'flooring', model: 'flooring', refcode: '', fabricator:'global' },
                        dataQas: 'global_header-custom-flooring-menu-link-child',
                        show: true
                    },
                    /* {
                        name: 'Custom Flooring',
                        queryString: '?type=soleria',
                        translationId: 'FLOOR',
                        routeId: 'ROUTE_CUT_TO_SIZE',
                        params: { outlet: '' },
                        dataQas: 'global_header-custom-floring-menu-link-child',
                        show: !this.props.isDBU
                    }, */
                    /* {
                        name: 'Baseboards',
                        queryString: '?type=rodapies',
                        translationId: 'rodapies',
                        routeId: 'ROUTE_CUT_TO_SIZE',
                        params: { outlet: '' },
                        dataQas: 'global_header-baseboards-menu-link-child',
                        show: !this.props.isDBU
                    }, */
                    {
                        name: 'Cladding',
                        queryString: '?type=cladding',
                        translationId: 'CTS_CLADDING',
                        routeId: 'ROUTE_CONFIG_CUT_TO_SIZE',
                        params: { type: 'cladding', model: 'cladding', refcode: '', fabricator:'global' },
                        dataQas: 'global_header-cladding-menu-link-child',
                        show: true
                    },
                    {
                        name: 'Furniture',
                        queryString: '?type=custom_mobiliario',
                        translationId: 'furniture',
                        routeId: 'ROUTE_CUT_TO_SIZE',
                        params: { outlet: '' },
                        show: this.props.canViewFurniture,
                        dataQas: 'global_header-furniture-menu-link-child'
                    },
                    {
                        name: 'Washbasing and shower trays',
                        queryString: '?type=configurable_bath',
                        translationId: 'washbasing_and_shower_trays',
                        routeId: 'ROUTE_CUT_TO_SIZE',
                        params: { outlet: '' },
                        show: this.props.canViewConfigurableBath,
                        dataQas: 'global_header-special-custom-projects-menu-link-child'
                    },
                    {
                        name: 'Special custom projects',
                        queryString: this.props.canViewPreorder ? '?type=preorder' : '?type=budget',
                        translationId: 'special_custom_projects',
                        routeId: 'ROUTE_CUT_TO_SIZE',
                        params: { outlet: '' },
                        dataQas: 'global_header-special-custom-projects-menu-link-child',
                        show: true
                    },
                    {
                        name: 'My saved configurations',
                        queryString: '',
                        translationId: 'my_saved_configurations',
                        routeId: 'ROUTE_CONFIG_CUT_TO_SIZE_FAVORITE',
                        params: { outlet: '' },
                        dataQas: 'global_header-my-saved-configurations-menu-link-child',
                        show: this.props.isLogged
                    }
                ]
            },
            // Professional Products
            {
                name: 'ppcc',
                routeId: 'ROUTE_CATALOG',
                queryString: getQueryStringFromTypes(ProductTypes.PROFESSIONAL),
                translationId: 'professional_products',
                params: { outlet: '' },
                customClassTag: 'ppcc',
                show: this.props.canViewCatalog && !this.props.canViewMktools && canViewProfessionalProducts(),
                dataQas: 'global_header-professional-products-menu-link',
                gtmLabel: 'ec_menu_header-ppcc',
                links: [
                    {
                        name: 'Silicones',
                        queryString: '?type[0]=SIL&subtype[0]=Colorsil&subtype[1]=Colordek',
                        translationId: 'silicones',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-silicones-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && (centerPreferences.canViewProductTypes.sil_colorsil || centerPreferences.canViewProductTypes.sil_colordek)
                    },
                    {
                        name: 'Adhesives',
                        queryString: '?type[0]=AD&subtype[0]=Solumastik&subtype[1]=Mastidek',
                        translationId: 'adhesives',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-adhesives-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && (centerPreferences.canViewProductTypes.ad_solumastik || centerPreferences.canViewProductTypes.ad_mastidek)
                    },
                    {
                        name: 'Tools',
                        queryString: getQueryStringFromTypes(ProductTypes.PROFESSIONAL.TOOL),
                        translationId: 'tools',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-tools-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.tool
                    },
                    {
                        name: 'Maintenance and cleaning',
                        queryString: getQueryStringFromTypes(ProductTypes.PROFESSIONAL.C_M),
                        translationId: 'maintenance_and_cleaning',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-maintenance-and-cleaning-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.c_m
                    },
                    {
                        name: 'Treatment and repair',
                        translationId: 'T&R',
                        queryString: getQueryStringFromTypes(ProductTypes.PROFESSIONAL['T&R']),
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-treatment-and-repair-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes['t&r']
                    },
                    {
                        name: 'Kitchen and bathroom accessories',
                        translationId: 'kitchen_and_bathroom_accessories',
                        queryString: getQueryStringFromTypes(ProductTypes.PROFESSIONAL['ACC']),
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-kitchen_and_bathroom_accessories-menu-link-child',
                        show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.acc
                    }
                ]
            },
            // Outlet
            {
                name: 'outlet',
                routeId: 'ROUTE_CATALOG',
                queryString: '',
                translationId: 'outlet',
                params: { outlet: 'outlet' },
                customClassTag: 'outlet',
                show: this.props.canViewCatalog && !this.props.canViewMktools,
                dataQas: 'global_header-outlet-menu-link',
                gtmLabel: 'ec_menu_header-outlet',
                links: outletBrandLinks
            },
            {
                name: 'Mall',
                routeId: 'ROUTE_LANDING_TEMPLATE',
                queryString: '',
                params: { slug: getMallLink(), outlet: '', preview: '', iso: '' },
                translationId: '',
                customClassTag: 'mall',
                show: showMall(),
                dataQas: 'global_header-mall-menu-link',
                links: this.props.userLandings
                    ? this.props.userLandings.map(landing => {
                          let today = new Date()
                          if (new Date(landing.end_at) > today) {
                              return {
                                  name: landing['slug'],
                                  routeId: 'ROUTE_LANDING_TEMPLATE',
                                  params: { slug: landing ? landing['slug'] : 'test', outlet: '', preview: '', iso: '' },
                                  translationId: '',
                                  show: true
                              }
                          }
                      })
                    : []
            },
            {
                name: 'marketing',
                routeId: 'ROUTE_CATALOG',
                queryString: '?webHeading[0]=MK',
                params: { outlet: '' },
                translationId: 'mktool',
                customClassTag: 'mktool',
                show: this.props.canViewMktools && !this.props.isWarehouse,
                dataQas: 'global_header-maketing-menu-link',
                links: [
                    {
                        name: 'Muestras',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=MK&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=01`
                            : '?webHeading[0]=MK&typeId[0]=01',
                        routeId: 'ROUTE_CATALOG',
                        translationId: 'SAMPLES',
                        params: { outlet: '' },
                        dataQas: 'global_header-muestras-menu-link-child',
                        show: true
                    },
                    {
                        name: 'Expositores y torres',
                        queryString: '?webHeading[0]=MK&typeId[0]=08',
                        translationId: 'DISPLAYS',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-expositores-torres-menu-link-child',
                        show: true
                    },
                    {
                        name: 'Cajas',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=MK&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=07`
                            : '?webHeading[0]=MK&typeId[0]=07',
                        translationId: 'BOXES',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-cajas-menu-link-child',
                        show: true
                    },
                    {
                        name: 'Test Kits',
                        translationId: 'TEST_KITS',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=MK&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=12`
                            : '?webHeading[0]=MK&typeId[0]=12',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-test-kits-menu-link-child',
                        show: true
                    },
                    {
                        name: 'Papeleria',
                        translationId: 'LITERATURE',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=MK&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=04`
                            : '?webHeading[0]=MK&typeId[0]=04',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-papeleria-menu-link-child',
                        show: true
                    },
                    {
                        name: 'Merchandising',
                        translationId: 'MERCHANDISING',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=MK&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=03`
                            : '?webHeading[0]=MK&typeId[0]=03',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-merchandising-menu-link-child',
                        show: true
                    }
                ]
            },
            {
                name: 'lowesBrochures',
                routeId: 'ROUTE_CATALOG_LOWES',
                queryString: '',
                translationId: 'brochures',
                params: { filter: 'brochures' },
                customClassTag: '',
                show: this.props.selectedCenter === this.props.lowesCenerId && this.props.userType !== 'ADMIN',
                dataQas: 'global_header-lowes-brochures-menu-link'
            },
            {
                name: 'lowesCustomerSamples',
                routeId: 'ROUTE_CATALOG_LOWES',
                queryString: '',
                translationId: 'customer_samples',
                params: { filter: 'customer-samples' },
                customClassTag: '',
                show: this.props.selectedCenter === this.props.lowesCenerId && this.props.userType !== 'ADMIN',
                dataQas: 'global_header-lowes-samples-menu-link'
            },
            {
                name: 'lowesAdmin',
                routeId: 'ROUTE_CATALOG_LOWES_ADMIN',
                queryString: '',
                translationId: 'lowes',
                params: { filter: 'home' },
                customClassTag: '',
                show: this.props.selectedCenter === this.props.lowesCenerId && this.props.userType === 'ADMIN',
                dataQas: 'global_header-lowes-admin-menu-link'
            },
            {
                name: 'showroom',
                routeId: 'ROUTE_CATALOG',
                queryString: this.props.mktoolShippingCenter ? `?webHeading[0]=SH&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}` : '?webHeading[0]=SH',
                params: { outlet: '' },
                translationId: 'showroom',
                customClassTag: 'showroom',
                dataQas: 'global_header-showroom-menu-link',
                show: this.props.canViewMktools && !this.props.isWarehouse,
                links: [
                    {
                        name: 'Identificadores',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=SH&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=05`
                            : '?webHeading[0]=SH&typeId[0]=05',
                        routeId: 'ROUTE_CATALOG',
                        translationId: 'TAGS',
                        params: { outlet: '' },
                        dataQas: 'global_header-identificadores-menu-link',
                        show: true
                    },
                    {
                        name: 'Anclajes',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=SH&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=06`
                            : '?webHeading[0]=SH&typeId[0]=06',
                        translationId: 'ANCHORING',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-anclajes-menu-link',
                        show: true
                    },
                    {
                        name: 'Expositores y torres',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=SH&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=07`
                            : '?webHeading[0]=SH&typeId[0]=08',
                        translationId: 'DISPLAYS',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        show: true
                    },
                    {
                        name: 'Mobiliario',
                        translationId: 'furniture',
                        queryString: this.props.mktoolShippingCenter
                            ? `?webHeading[0]=SH&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}&typeId[0]=10`
                            : '?webHeading[0]=SH&typeId[0]=10',
                        routeId: 'ROUTE_CATALOG',
                        params: { outlet: '' },
                        dataQas: 'global_header-mobiliario-menu-link',
                        show: true
                    }
                ]
            },
            {
                name: 'warehouse',
                routeId: 'ROUTE_CATALOG',
                queryString: this.props.mktoolShippingCenter ? `?webHeading[0]=WH&mktoolShippingCenter[0]=${this.props.mktoolShippingCenter}` : '?webHeading[0]=WH',
                params: { outlet: '' },
                translationId: 'warehouse',
                customClassTag: 'warehouse',
                show: this.props.canViewMktools && this.props.isWarehouse,
                dataQas: 'global_header-warehouse-menu-link'
            }
        ]
        let links = [
            {
                name: 'slabs',
                routeId: 'ROUTE_CATALOG',
                queryString: getQueryStringFromTypes(ProductTypes.SLAB),
                params: { outlet: '' },
                translationId: 'tables',
                customClassTag: 'slabs',
                show: centerPreferences && centerPreferences.canViewProductTypes && centerPreferences.canViewProductTypes.slab && this.props.canViewCatalog,
                gtmLabel: 'ec_home_banner_seccion-slabs'
            },
            {
                name: 'standard products',
                routeId: 'ROUTE_CATALOG',
                queryString: getQueryStringFromTypes([
                    ...ProductTypes.BATHROOM.toArray(),
                    ...ProductTypes.COVERING.toArray(),
                    ...ProductTypes.FLOORING_AND_CLADDING.toArray(),
                    ...ProductTypes.FLOORING_AND_CLADDING_DERIVATED.toArray()
                ]),
                params: { outlet: '' },
                translationId: 'standard_products',
                customClassTag: 'standard',
                show: this.props.canViewCatalog && !this.props.canViewMktools && canViewStandardProducts(),
                gtmLabel: 'ec_home_banner_seccion-standard'
            },
            {
                name: 'custom products',
                routeId: 'ROUTE_CUT_TO_SIZE',
                queryString: '',
                translationId: 'custom_products',
                params: { outlet: '' },
                customClassTag: 'cts',
                show: this.props.canViewCutToSize && this.props.isLogged,
                gtmLabel: 'ec_home_banner_seccion-cts'
            },
            {
                name: 'ppcc',
                routeId: 'ROUTE_CATALOG',
                queryString: getQueryStringFromTypes(ProductTypes.PROFESSIONAL),
                translationId: 'professional_products',
                params: { outlet: '' },
                customClassTag: 'ppcc',
                show: this.props.canViewCatalog && !this.props.canViewMktools && canViewProfessionalProducts(),
                gtmLabel: 'ec_home_banner_seccion-ppcc'
            },
            {
                name: 'outlet',
                routeId: 'ROUTE_CATALOG',
                queryString: '',
                translationId: 'outlet',
                params: { outlet: 'outlet' },
                customClassTag: 'outlet',
                show: this.props.canViewCatalog && !this.props.canViewMktools,
                gtmLabel: 'ec_home_banner_seccion-outlet'
            },
            {
                name: 'promo',
                routeId: 'ROUTE_CATALOG',
                queryString: '?type[0]=SLAB&promo=true',
                translationId: 'promotions',
                params: { outlet: '' },
                customClassTag: '',
                show: this.props.hasPromoActivated
            },
            {
                name: 'lowesBrochures',
                routeId: 'ROUTE_CATALOG_LOWES',
                queryString: '',
                translationId: 'brochures',
                params: { filter: 'brochures' },
                customClassTag: '',
                show: this.props.selectedCenter === this.props.lowesCenerId && this.props.userType !== 'ADMIN'
            },
            {
                name: 'lowesCustomerSamples',
                routeId: 'ROUTE_CATALOG_LOWES',
                queryString: '',
                translationId: 'customer_samples',
                params: { filter: 'customer-samples' },
                customClassTag: '',
                show: this.props.selectedCenter === this.props.lowesCenerId && this.props.userType !== 'ADMIN'
            },
            {
                name: 'lowesAdmin',
                routeId: 'ROUTE_CATALOG_LOWES_ADMIN',
                queryString: '',
                translationId: 'lowes',
                params: { filter: 'home' },
                customClassTag: '',
                show: this.props.selectedCenter === this.props.lowesCenerId && this.props.userType === 'ADMIN'
            },
            {
                name: 'profile',
                routeId: 'ROUTE_PROFILE',
                queryString: '',
                translationId: 'profile',
                customClassTag: 'profile',
                params: { filter: 'configuration', open: '' },
                show: this.props.canViewCatalog
            },
            {
                name: 'mkTool',
                routeId: 'ROUTE_CATALOG',
                queryString: mktoolShippingCenter ? `?webHeading[0]=MK&mktoolShippingCenter[0]=${mktoolShippingCenter}` : '?webHeading[0]=MK',
                translationId: 'mktool',
                params: { outlet: '' },
                customClassTag: '',
                show:
                    this.props.canViewCatalog &&
                    this.props.canViewMktools &&
                    this.props.centerMktool &&
                    (this.props.selectedCenter === this.props.showroomCenterId || this.props.selectedCenter === this.props.DRIUSACenterId)
            },
            {
                name: 'showRoom',
                routeId: 'ROUTE_CATALOG',
                queryString: mktoolShippingCenter ? `?webHeading[0]=SH&mktoolShippingCenter[0]=${mktoolShippingCenter}` : '?webHeading[0]=SH',
                translationId: 'showroom',
                params: { outlet: '' },
                customClassTag: '',
                show:
                    this.props.canViewCatalog &&
                    this.props.canViewMktools &&
                    this.props.centerShowroom &&
                    (this.props.selectedCenter === this.props.showroomCenterId || this.props.selectedCenter === this.props.DRIUSACenterId)
            },
            {
                name: 'warehouse',
                routeId: 'ROUTE_CATALOG',
                queryString: '?webHeading[0]=WH',
                params: { outlet: '' },
                translationId: 'warehouse',
                customClassTag: '',
                show: this.props.canViewCatalog &&
                    this.props.canViewMktools &&
                    this.props.centerWarehouse &&
                    this.props.selectedCenter === this.props.warehoseCenterId
            }
        ]

        const LinkList = ({ children, responsive, customClass = '', index }) => (
            <li
                className={responsive ? 'nav-item ' + customClass : customClass}
                onClick={() => {
                    if (customClass) {
                        let elementsClass = customClass.split(' ')
                        let selector = (elementsClass[0].length > 0 ? `.${elementsClass[0]}` : '') + (elementsClass[1].length > 0 ? `.${elementsClass[1]}` : '')
                        let element = selector !== '' ? document.querySelectorAll(selector) : null
                        if (element && element[0]) {
                            if (element[0].children && element[0].children[0]) {
                                element[0].children[0].click()
                            }
                        }
                    }
                    if (responsive) {
                        ;[...document.querySelectorAll(`#responsive-extra-menu-${index}`)].forEach(e => {
                            e.hidden = !e.hidden
                        })
                        ;[...document.querySelectorAll(`#arrow-down-${index}`)].forEach(e => {
                            e.hidden = !e.hidden
                        })
                        ;[...document.querySelectorAll(`#arrow-up-${index}`)].forEach(e => {
                            e.hidden = !e.hidden
                        })
                    }
                }}
            >
                {children}
            </li>
        )

        const settings = {
            arrows: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            swipeToSlide: true,
            dots: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: false
        }

        let hasBackground = false

        return (
            <React.Fragment>
                {!this.props.comp && !this.props.footer && (
                    <div className={'product-links-container'}>
                        {links.map(
                            (value, index) =>
                                value.show && (
                                    <LinkList
                                        className="link-hover"
                                        responsive={responsive}
                                        params={values.params ? values.params : {}}
                                        customClass={(customClass ? customClass : '') + ` ${value.customClassTag}`}
                                        key={index}
                                    >
                                        <LocalizedLink
                                            routeId={value.routeId}
                                            queryString={value.queryString}
                                            params={value.params}
                                            className={responsive ? 'nav-link' : null}
                                            gtmLabel={value.gtmLabel}
                                        >
                                            <Translation id={value.translationId} />
                                        </LocalizedLink>
                                    </LinkList>
                                )
                        )}
                    </div>
                )}
                {!this.props.comp && !this.props.footer && (
                    <div className={'container product-links-slider-container'}>
                        <Slider {...settings}>
                            {links
                                .filter(value => {
                                    //TODO Refactor this please
                                    return ['slabs', 'ppcc', 'elaborados', 'sinks', 'outlet', 'standard', 'cts'].includes(value.customClassTag)
                                })
                                .map(
                                    (value, index) =>
                                        value.show && (
                                            <div key={index}>
                                                <div style={{ margin: '0 10px' }}>
                                                    <LinkList
                                                        className="link-hover"
                                                        responsive={responsive}
                                                        params={values.params ? values.params : {}}
                                                        customClass={(customClass ? customClass : '') + ` ${value.customClassTag}`}
                                                        key={index}
                                                    >
                                                        <LocalizedLink
                                                            routeId={value.routeId}
                                                            queryString={value.queryString}
                                                            params={value.params}
                                                            className={responsive ? 'nav-link' : null}
                                                        >
                                                            <Translation id={value.translationId} />
                                                        </LocalizedLink>
                                                    </LinkList>
                                                </div>
                                            </div>
                                        )
                                )}
                        </Slider>
                    </div>
                )}
                {this.props.footer &&
                    linksMenu.map(
                        (value, index) =>
                            value.show && (
                                <LinkList
                                    className="link-hover"
                                    responsive={responsive}
                                    params={values.params ? values.params : {}}
                                    customClass={(customClass ? customClass : '') + ` ${value.customClassTag}`}
                                    key={index}
                                >
                                    <LocalizedLink routeId={value.routeId} queryString={value.queryString} params={value.params} className={responsive ? '' : null}>
                                        {value.translationId && <Translation id={value.translationId} />}
                                        {!value.translationId && value.name}
                                    </LocalizedLink>
                                </LinkList>
                            )
                    )}
                {this.props.comp && (
                    <ul
                        className={`nav-burger ${responsive ? 'responsive' : ''}`}
                        onMouseOver={() => {
                            if (!responsive) {
                                let backgroundHeight = 0
                                //document.querySelectorAll(".header-links-separator").forEach(e => e.hidden = false);
                                document.querySelectorAll(".extra-menu").forEach(e => {
                                    e.hidden = false
                                    e.classList.add("fade-in")
                                    backgroundHeight = Math.max(backgroundHeight, e.offsetHeight + 10)
                                })
                                document.querySelectorAll(".background").forEach(e => {
                                    e.hidden = false
                                    e.style.height = backgroundHeight + 'px'
                                })
                            }
                        }}
                        onMouseOut={() => {
                            if (!responsive) {
                                //document.querySelectorAll(".header-links-separator").forEach(e => e.hidden = true);
                                document.querySelectorAll(".extra-menu").forEach(e => {
                                    e.hidden = true
                                    e.classList.remove("fade-in")
                                })
                                document.querySelectorAll(".background").forEach(e => e.hidden = true);
                            }
                        }}
                    >
                        {linksMenu.map((value, index) => {
                            return (
                                value.show && (
                                    <li
                                        className="link-hover"
                                        index={index}
                                        responsive={responsive}
                                        params={values.params ? values.params : {}}
                                        customClass={(customClass ? customClass : '') + ` ${value.customClassTag} header-menu-link ${responsive ? 'responsive' : ''}`}
                                        key={index}
                                    >
                                        <LocalizedLink
                                            routeId={value.routeId}
                                            header={true}
                                            params={value.params}
                                            queryString={value.queryString}
                                            className="a-hover-menu v2"
                                            dataQas={value.dataQas}
                                            gtmLabel={value.gtmLabel}
                                        >
                                            {value.translationId && <Translation id={value.translationId} />}
                                            {!value.translationId && value.name}
                                        </LocalizedLink>
                                        {responsive && (
                                            <React.Fragment>
                                                <span
                                                    className="arrow-down"
                                                    id={`arrow-down-${index}`}
                                                    onClick={() => {
                                                        ;[...document.querySelectorAll(`#responsive-extra-menu-${index}`)].forEach(e => {
                                                            e.hidden = !e.hidden
                                                        })
                                                        ;[...document.querySelectorAll(`#arrow-down-${index}`)].forEach(e => {
                                                            e.hidden = !e.hidden
                                                        })
                                                        ;[...document.querySelectorAll(`#arrow-up-${index}`)].forEach(e => {
                                                            e.hidden = !e.hidden
                                                        })
                                                    }}
                                                >
                                                    <i className={`fal fa-chevron-down`}></i>
                                                </span>
                                                <span
                                                    className="arrow-down"
                                                    id={`arrow-up-${index}`}
                                                    hidden={true}
                                                    onClick={() => {
                                                        ;[...document.querySelectorAll(`#responsive-extra-menu-${index}`)].forEach(e => {
                                                            e.hidden = !e.hidden
                                                        })
                                                        ;[...document.querySelectorAll(`#arrow-down-${index}`)].forEach(e => {
                                                            e.hidden = !e.hidden
                                                        })
                                                        ;[...document.querySelectorAll(`#arrow-up-${index}`)].forEach(e => {
                                                            e.hidden = !e.hidden
                                                        })
                                                    }}
                                                >
                                                    <i className={`fal fa-chevron-up`}></i>
                                                </span>
                                            </React.Fragment>
                                        )}
                                        {!hasBackground && <div className="background shadow-sm" hidden={true} gtm-label="ec_submenu_header" />}
                                        {(hasBackground = true)}
                                        <div className="extra-menu" id={window.innerWidth <= 1199 ? `responsive-extra-menu-${index}` : `extra-menu-${index}`} hidden={true}>
                                            <ul className={`group-links header-menu-link`}>
                                                {value.links &&
                                                    value.links.map((link, i) => {
                                                        // Si es un grupo (Natural Stone)
                                                        if (link && link.isNaturalStoneGroupTitle) {
                                                            return (
                                                                <li key={i} className="natural-stone-group">
                                                                    <div className="natural-stone-link">
                                                                        <LocalizedLink
                                                                            routeId={link.routeId}
                                                                            params={link.params}
                                                                            gtmLabel="ec_submenu_header"
                                                                        >
                                                                            {link.translationId ? <Translation id={link.translationId} /> : link.name} <span className="label-new">
                                                                            (<Translation id="new" defaultMessage="New" />)
                                                                        </span>
                                                                        </LocalizedLink>
                                                                    </div>
                                                                    <ul className="nested-links">
                                                                        {link.links.map(
                                                                            (subLink, j) =>
                                                                                subLink.show && (
                                                                                    <LinkList
                                                                                        className="link-hover"
                                                                                        responsive={responsive}
                                                                                        params={values.params ? values.params : {}}
                                                                                        key={j}
                                                                                    >
                                                                                        <LocalizedLink
                                                                                            routeId={subLink.routeId}
                                                                                            header={true}
                                                                                            params={subLink.params}
                                                                                            queryString={subLink.queryString}
                                                                                            className={`${responsive ? 'nav-link' : null} sub-menu-link v2`}
                                                                                            dataQas={subLink.dataQas}
                                                                                            gtmLabel="ec_submenu_header"
                                                                                        >
                                                                                            {subLink.translationId ? <Translation id={subLink.translationId} /> : subLink.name}
                                                                                        </LocalizedLink>
                                                                                    </LinkList>
                                                                                )
                                                                        )}
                                                                    </ul>
                                                                </li>
                                                            )
                                                        }

                                                        // Si es un enlace normal
                                                        return (
                                                            link && link.show && (
                                                                <LinkList className="link-hover" responsive={responsive} params={values.params ? values.params : {}} key={i}>
                                                                    <LocalizedLink
                                                                        routeId={link.routeId}
                                                                        header={true}
                                                                        params={link.params}
                                                                        queryString={link.queryString}
                                                                        className={`${responsive ? 'nav-link' : null} sub-menu-link v2`}
                                                                        dataQas={link.dataQas}
                                                                        gtmLabel="ec_submenu_header"
                                                                    >
                                                                        {link.translationId ? <Translation id={link.translationId} /> : link.name}
                                                                    </LocalizedLink>
                                                                </LinkList>
                                                            )
                                                        )
                                                    })}
                                            </ul>
                                        </div>
                                    </li>
                                )
                            )
                        })}
                    </ul>
                )}
            </React.Fragment>
        )
    }
}

export default MenuLinksV2

function SampleNextArrow(props) {
    const { style, onClick } = props
    return (
        <i
            className={'fal fa-chevron-right'}
            style={{ ...style, display: 'block', position: 'absolute', right: 0, top: '40%', fontSize: '30px', cursor: 'pointer', zIndex: '10' }}
            onClick={onClick}
        />
    )
}

function SamplePrevArrow(props) {
    const { style, onClick } = props
    return (
        <i
            className={'fal fa-chevron-left'}
            style={{ ...style, display: 'block', position: 'absolute', top: '40%', fontSize: '30px', cursor: 'pointer', zIndex: '10' }}
            onClick={onClick}
        />
    )
}
